import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { isNullOrUndefined } from '../../utils';

@Component({
  selector: 'trg-tabs',
  templateUrl: './trg-tabs.component.html',
  styleUrls: ['./trg-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TrgTabsComponent implements OnInit, OnChanges {
  @Input() disabled = false;

  @Input() tabs: string[] = [];

  @Input() selectedTab: string = null;
  @Output() selectedTabChange = new EventEmitter<string>();

  @Input() selectedTabIndex: number = -1;
  @Output() selectedTabIndexChange = new EventEmitter<number>();

  @Input() maxTabWidth: number = null;
  @Input() tabHeight: number = 36;

  @Input() underline = false;

  tabStyle = '';

  constructor() { }

  ngOnInit() {
    this.updateStyles();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.maxTabWidth || changes.tabHeight) {
      this.updateStyles();
    }
  }

  setSelectedTab(index: number) {
    if (this.disabled)
      return;

    if (index === this.selectedTabIndex)
      return;

    this.selectedTabIndex = index;
    this.selectedTab = this.tabs[index];

    this.selectedTabIndexChange.emit(this.selectedTabIndex);
    this.selectedTabChange.emit(this.selectedTab);
  }

  private updateStyles() {
    let tabStyle = [];

    if (!isNullOrUndefined(this.maxTabWidth))
      tabStyle.push(`max-width: ${this.maxTabWidth}px`);

    if (!isNullOrUndefined(this.tabHeight))
      tabStyle.push(`height: ${this.tabHeight}px`);

    this.tabStyle = tabStyle.join(';');
  }
}
